import { Button } from 'ui-components/components/button';
import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import styles from './product-row-label.styles.module.less';

type ProductRowLabelProps = {
  name: string;
  sku: string;
  productId: number;
  openProductDetails: (productId: number) => void;
  isFirstProductRow: boolean;
};

export const ProductRowLabel = ({ name, sku, productId, openProductDetails, isFirstProductRow }: ProductRowLabelProps) => {
  if (!isFirstProductRow) {
    return <div className={styles['empty-cell']} />;
  }

  return (
    <FlexColumn className={styles['flex-label']}>
      <Button className={styles['name-label']} onClick={() => openProductDetails(productId)} theme={THEME_CONSTANTS.link}>
        {name}
      </Button>
      <Text className={styles['sku-label']} textType={TextType.Caption} value={`SKU: ${sku}`} />
    </FlexColumn>
  );
};
